import React, { useState, useEffect, useRef } from "react";
import "./style.scss";
import classNames from "classnames";
import { BodyText, Heading } from "../../elements";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import PrimaryButton from "../../elements/primary-button";
import { loadScrollMagic, mobileIs, getOverallSettingsClasses } from "../../utils/siteUtils";
import { gtag } from "../../utils"
import gsap from "gsap";

const SimpleText = props => {
  const { fields, rendering, page } = props;
  let { headingTitleFontColor, headingType, headingBody, mobile_headingBody, body, mobile_body, cta, headingTitle, mobile_headingTitle } = fields;
  // console.log(fields, "SimpleText");
  const isMobile = mobileIs();

  let state = true;
  let tl = null;
  let scene = null;
  let controller = null;
  const mainEl = useRef(null);
  const rootId = `simple-text__${rendering.uid}`;
  const mainId = `simple-text__main${rendering.uid}`;
	const firstTitleHeaderClass = `simple-text__first-title-header${rendering.uid}`;
  const titleHeaderClass = `simple-text__title-header${rendering.uid}`;
  const titleBodyClass = `simple-text__title-body${rendering.uid}`;
  const buttonClass = `simple-text__button${rendering.uid}`;

  const handleScroll = () => {
    if (!mainEl?.current) return;
    const rect = mainEl?.current.getBoundingClientRect();
    const winHeight = window.innerHeight || document.documentElement.clientHeight;
    const inScreen = (rect.top >= 0 && rect.top <= winHeight) || (rect.bottom >= 0 && rect.bottom <= winHeight);
    let scrollDirection = controller.info("scrollDirection");
    if(!state && rect.top >= winHeight && scrollDirection === "REVERSE"){
      tl && tl.revert();
      state = true;
    }
    if (state && inScreen && scrollDirection === "FORWARD") {
      tl && tl.restart();
      state = false;
    }
  };

  useEffect(() => {
    const ScrollMagic = loadScrollMagic();
    controller = new ScrollMagic.Controller();
    tl = gsap.timeline({paused: true});
    // tl = gsap.timeline();
		// firstTitleHeaderClass
    tl.add(
      gsap.to(`.${firstTitleHeaderClass}`, {
        y: 0,
        opacity: 1,
      }),
      0
    )
			.add(
				gsap.to(`.${titleHeaderClass}`, {
					y: 0,
					opacity: 1,
				}),
				0
			)
      .add(
        gsap.to(`.${titleBodyClass}`, {
          y: 0,
          opacity: 1,
          delay: 0.3
        }),
        0
      )
      .add(
        gsap.to(`.${buttonClass}`, {
          y: 0,
          opacity: 1,
          delay: 0.5
        }),
        0
      );
    scene = new ScrollMagic.Scene({
      triggerElement: `#${rootId}`,
      triggerHook: "onCenter",
      reverse: false
    })
      // .setTween(tl)
      .addTo(controller);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      scene.destroy(true);
      scene = null;
      controller.destroy(true);
      controller = null;
    };
  }, []);
  const btnClick = () => {
    gtag('event', 'Component_info', {
      'component_name': 'SimpleText',
      'page_title': page?.name
    });
  }

  const TextClasses = classNames("simple-text grid", getOverallSettingsClasses(fields));
  const titleHeaderClasses = classNames(`simple-text__title-header ${titleHeaderClass}`);
	const firstTitleHeaderClasses = classNames(`simple-text__first-title-header ${firstTitleHeaderClass}`);
  const titleBodyClasses = classNames(`simple-text__title-body ${titleBodyClass}`);
  const buttonClasses = classNames(`simple-text__button ${buttonClass}`);
  return (
    <div id={rootId} className={TextClasses} datasourceid={rendering.dataSource}>
      <div className={"simple-text__main"} id={mainId} ref={mainEl}>
        <div className={"simple-text__title"}>
          {!isMobile && (
            <>
              <RichText tag="div" className={firstTitleHeaderClasses} field={headingTitle} style={{ color: headingTitleFontColor?.value }} />
              <RichText tag="div" className={titleHeaderClasses} field={headingBody} style={{ fontSize: headingTitle?.value ? '60px' : '40px' }} />
              <BodyText className={titleBodyClasses} html={body} />
            </>
          )}
          {isMobile && (
            <>
              <RichText tag="div" className={firstTitleHeaderClasses} field={mobile_headingTitle} style={{ color: headingTitleFontColor?.value }} />
              <RichText tag="div" className={titleHeaderClasses} field={mobile_headingBody} style={{ fontSize: mobile_headingTitle?.value ? '40px' : '30px' }} />
              <BodyText className={titleBodyClasses} html={mobile_body} />
            </>
          )}
        </div>
        {cta && (
          <div className={buttonClasses} onClick={btnClick} >
            <PrimaryButton
              {...{
                ...cta?.fields
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default SimpleText;
